import { FC } from 'react';
import { IconProps } from '../../types';

export const Silver2: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_58463)"
      />
      <path
        d="M6.85191 3.888V5.016C6.53991 4.824 6.23991 4.644 5.86791 4.644C5.71191 4.644 5.59191 4.68 5.53191 4.704C5.08791 4.86 4.87191 5.304 4.87191 5.748C4.88391 6.156 5.05191 6.468 5.30391 6.768C5.60391 7.14 5.93991 7.476 6.26391 7.812C6.85191 8.436 7.19991 8.868 7.19991 9.756C7.19991 9.948 7.18791 10.644 6.83991 11.208C6.68391 11.448 6.49191 11.64 6.26391 11.784C5.83191 12.06 5.42391 12.072 5.24391 12.072C4.59591 12.072 4.16391 11.844 3.93591 11.736V10.572C4.04391 10.632 4.52391 10.956 5.05191 10.956C5.31591 10.956 5.50791 10.872 5.59191 10.812C5.74791 10.704 6.03591 10.38 6.03591 9.852C6.03591 9.144 5.62791 8.844 4.78791 7.956C4.17591 7.296 3.69591 6.768 3.69591 5.808C3.69591 5.592 3.71991 5.004 4.04391 4.476C4.23591 4.176 4.71591 3.54 5.68791 3.54C6.27591 3.54 6.65991 3.78 6.85191 3.888ZM8.988 6.336H7.896C7.92 5.292 7.968 4.596 8.22 4.2C8.292 4.092 8.46 3.888 8.772 3.732C8.928 3.648 9.252 3.516 9.684 3.516C9.816 3.516 10.632 3.552 11.088 3.996C11.172 4.08 11.28 4.212 11.376 4.452C11.556 4.896 11.568 5.496 11.568 5.604C11.568 6.156 11.46 6.516 11.28 7.056C10.872 8.1 10.668 8.52 10.14 9.516L9.336 10.992H11.412V12H7.692L9.324 8.676C9.768 7.752 10.368 6.516 10.368 5.52C10.368 4.74 10.068 4.488 9.684 4.488C9.6 4.488 9.408 4.5 9.264 4.656C8.976 4.944 9.012 5.364 9 5.736C9 5.94 8.988 6.132 8.988 6.336Z"
        fill="#F8F8F8"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6141_58463"
          x1="7"
          y1="18"
          x2="7"
          y2="-3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#868686" />
          <stop offset="0.239" stopColor="#646464" />
          <stop offset="0.464" stopColor="#C6C6C6" />
          <stop offset="1" stopColor="#7E7E7E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
